import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sample-card',
  templateUrl: './sample-card.component.html',
  styleUrls: ['./sample-card.component.scss'],
})
export class SampleCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
